export default "__VITE_ASSET__8fpEyvqT__"